<template>
  <div :class="{ 'form-control': true, 'is-select': true }">
    <v-select
      :options="customers"
      v-model="customer_id"
      :reduce="customer => customer.id"
      :filterBy="filterByForCustomers"
      :placeholder="placeholderText"
      label="name"
      @search="debouncedFetchCustomers">
      <template slot="no-options">
        <template v-if="!emptyResults">{{ $t('ui.searching') }}&hellip;</template>
        <template v-if="emptyResults">{{ $t('customer.noCustomerMarchingPhraseFound') }}&hellip;</template>
      </template>
      <template slot="option" slot-scope="option">
        <div class="d-center">
          {{ option.name }}
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div class="selected d-center">
          {{ option.name }}
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'select-customer',
  props: {
    customerID: {
      type: [String, Number]
    },
    customerType: {
      type: String
    },
    isInPopup: {
      default: false,
      type: Boolean
    },
    returnCustomerName: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    placeholderText () {
      if (this.customerType === 'market') {
        return this.$t('customer.selectMarketCustomer');
      } else if (this.customerType === 'potential') {
        return this.$t('customer.selectPotentialCustomer');
      }

      return this.$t('customer.selectCustomer');
    }
  },
  watch: {
    customer_id (newValue) {
      if (this.customerType === 'market') {
        this.$bus.$emit('ui-select-market-customer-updated', newValue);
      } else if (this.customerType === 'potential') {
        this.$bus.$emit('ui-select-potential-customer-updated', newValue);
      } else if (this.isInPopup) {
        this.$bus.$emit('ui-select-customer-updated-in-popup', newValue);
      } else if (this.returnCustomerName) {
        let customerName = '';

        if (newValue) {
          let foundedCustomer = this.customers.filter(customer => customer.id === newValue);

          if (foundedCustomer[0]) {
            customerName = foundedCustomer[0].name;
          }
        }

        this.$bus.$emit('ui-select-customer-updated', {
          customerID: newValue,
          customerName
        });
      } else {
        this.$bus.$emit('ui-select-customer-updated', newValue);
      }
    }
  },
  data () {
    return {
      customer_id: null,
      customers: [],
      emptyResults: false
    }
  },
  mounted () {
    this.endpointBase = '/customers';

    if (this.customerType === 'market') {
      this.endpointBase = '/market-customers';
    } else if (this.customerType === 'potential') {
      this.endpointBase = '/potential-customers';
    }

    this.customer_id = this.customerID;

    if (this.customer_id) {
      this.prefetchCustomer(this.customer_id);
    } else {
      this.customer_id = null;

      FormUtils.loadAdditionalData(this, {
        endpoint: this.endpointBase + '/items',
        outputKey: 'customers',
        errorKey: 'loadCustomersError'
      });
    }

    this.$bus.$on('ui-select-customer-reset', this.resetValue);
  },
  methods: {
    filterByForCustomers (option, label, search) {
      return (option.name + ' ' + option.email).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    prefetchCustomer (customerID) {
      if (!customerID) {
        return;
      }

      FormUtils.loadAdditionalData(this, {
        endpoint: this.endpointBase + '/item/' + parseInt(customerID, 10),
        outputKey: 'customers',
        errorKey: 'loadCustomersError',
        wrapResponseIntoArray: true,
        successAction: () => {
          this.customer_id = parseInt(customerID, 10);
        }
      });
    },
    fetchCustomers (searchPhrase, loadingCallback) {
      this.emptyResults = false;
      loadingCallback(true);

      let endpointUrl = this.endpointBase + '/items';
      let responseAsArray = false;
      let paramsData = {};

      if (searchPhrase !== '') {
        paramsData.where = {
          search: searchPhrase
        };
      }

      if (this.customer_id !== 0 && this.customer_id !== null && searchPhrase === '') {
        endpointUrl = this.endpointBase + '/item/' + parseInt(this.customer_id, 10);
        responseAsArray = true;
      }

      FormUtils.loadAdditionalData(this, {
        endpoint: endpointUrl,
        outputKey: 'customers',
        errorKey: 'loadCustomersError',
        params: paramsData,
        wrapResponseIntoArray: responseAsArray,
        successAction: (response) => {
          if (!response.length) {
            this.emptyResults = true;
          }

          loadingCallback(false);
        }
      });
    },
    // eslint-disable-next-line
    debouncedFetchCustomers: debounce(function (searchPhrase, loadingCallback) {
      this.fetchCustomers(searchPhrase, loadingCallback);
    }, 500),
    resetValue () {
      this.customer_id = null;
    }
  },
  beforeDestroy () {
    this.$bus.$off('ui-select-customer-reset', this.resetValue);
  }
}
</script>

<style lang="scss" scoped>
.is-v-select-wrapper > div {
  width: 100%;
}
</style>
